import { FC, useContext } from "react"
import { Controller } from "react-hook-form"
import Select from "react-select"
import { Col, Input, Label, Row } from "reactstrap"
import { AppContext } from "../../../../../context"
import { CommissionOverwritesProps } from "../../../../../interfaces"
import { customSelectStyleNew } from "../../../../styled/customSelect"

const Form: FC<CommissionOverwritesProps> = ({ serial, setValue, id, register, errors, isLast,
  remove, percentage, note, recruiterDealId, type, validDays, setDisableAdd, getValues, control, commissionOverwritesForDel, setCommissionOverwritesForDel }) => {
  const { theme } = useContext(AppContext)


  return (
    <>
      <Col className="mb-4" sm='12'>
        <Row>
          <Col sm="12" className="d-flex align-items-center justify-content-between my-3"><Label className="text-14 text-blackele p-0 m-0">Commission {serial + 1}</Label>
            <button className="remove-tier-btn" onClick={() => {
              if (getValues(`commissionOverwrites.${serial}.commissionId`)) {
                setCommissionOverwritesForDel([...commissionOverwritesForDel, getValues(`commissionOverwrites.${serial}.commissionId`)])
              }
              remove(serial)
            }}>- Remove Row </button>
          </Col>
          <Controller
            name={`commissionOverwrites.${serial}.commissionId`}
            defaultValue={id}
            control={control}
            render={({ field }) => <input {...field} type="hidden" />}
          />
          <Col sm='8' className="mb-3">
            <Label className="text-14 text-blackele pb-2">Overwrite Type <span className="text-danger">*</span></Label>
            <Controller
              name={`commissionOverwrites.${serial}.type`}
              defaultValue={type ? { value: type?.toUpperCase(), label: type } : null}
              rules={{ required: { value: true, message: "Overwrite Type is a required field" } }}
              control={control}
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value}
                  options={[{ value: "REFERRAL", label: "Referral" }, { value: "TEAM", label: "Team" }]}
                  onChange={(val) => onChange(val)}
                  styles={{ ...customSelectStyleNew(theme) }}
                  placeholder="Select Type"
                />
              )}
            />
            <small className="text-danger pt-2">
              {(errors as any)?.commissionOverwrites?.[serial]?.type?.message as React.ReactNode}
            </small>
          </Col>

          <Col sm='6' className="mb-3 custom-form-input form-input">
            <Label className="text-14 text-blackele pb-2">Valid Days {
              getValues().type?.value === 'REFERRAL' && <span className="text-danger">*</span>} </Label>
            <Controller
              name={`commissionOverwrites.${serial}.validDays`}
              defaultValue={validDays}
              rules={{ required: { value: getValues().type?.value === 'REFERRAL', message: "Valid Days is a required field" } }}
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  placeholder="Valid Days"
                  type="text"
                  onChange={({ target: { value } }) => {
                    const filteredValue = value.replace(/,/g, '').replace(/\D/g, "")
                    const newValue = filteredValue.slice(0, 3);
                    field.onChange(newValue);
                    setValue(`commissionOverwrites.${serial}.validDays`, newValue)
                  }}
                  onFocus={(value) => value.target.value && setValue(`commissionOverwrites.${serial}.validDays`, value.target.value.replaceAll(" days", ""))}
                  onBlur={(value) => value.target.value && setValue(`commissionOverwrites.${serial}.validDays`, value.target.value + " days")}
                />
              )}
            />
            <small className="text-danger pt-2">
              {(errors as any)?.commissionOverwrites?.[serial]?.validDays?.message as React.ReactNode}
            </small>
          </Col>

          <Col sm='6' className="mb-3 custom-form-input form-input">
            <Label className="text-14 text-blackele pb-2">Overwrite Percentage <span className="text-danger">*</span></Label>
            <Controller
              name={`commissionOverwrites.${serial}.percentage`}
              defaultValue={percentage?.replaceAll(" ", "")}
              rules={{ required: { value: true, message: "Overwrite Percentage is a required field" } }}
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  placeholder="Overwrite Percentage"
                  type="text"
                  onChange={({ target: { value } }) => {
                    const filteredValue = value.replace(/,/g, '').replace(/[^\d.]/g, "").replace(/^\./, "0.")
                    const newValue = filteredValue.slice(0, 4);
                    field.onChange(newValue);
                    setValue(`commissionOverwrites.${serial}.percentage`, newValue)
                  }}
                  onFocus={(value) => value.target.value && setValue(`commissionOverwrites.${serial}.percentage`, value.target.value.replaceAll("%", "").replaceAll(" ", ""))}
                  onBlur={(value) => value.target.value && setValue(`commissionOverwrites.${serial}.percentage`, value.target.value + "%")}
                />
              )}
            />
            <small className="text-danger pt-2">
              {(errors as any)?.commissionOverwrites?.[serial]?.percentage?.message as React.ReactNode}
            </small>
          </Col>

          <Col sm='12' className="mb-3 custom-form-input form-input">
            <Label className="text-14 text-blackele pb-2">Note </Label>
            <Controller
              name={`commissionOverwrites.${serial}.note`}
              rules={{ required: { value: false, message: "Note is a required field" } }}
              control={control}
              defaultValue={note}
              render={({ field }) => (
                <Input
                  {...field}
                  placeholder="Enter note"
                  type="text"
                />
              )}
            />
            <small className="text-danger pt-2">
              {(errors as any)?.commissionOverwrites?.[serial]?.note?.message as React.ReactNode}
            </small>
          </Col>
        </Row>
      </Col >
    </>)
}
export default Form